var points = 0;
var quantity = 1;
var reward_value = 0;
var points_price = 0;

window.addEventListener(
  "lb-upsell-widget-event",
  function (e) {
    if (e.detail && e.detail.status && e.detail.status === "rendered") {
      // Handle your functions here
      // e.detail.widgetType have the widget's type that being rendered.
      console.log("selleasy has loaded");
    
      var offerTitles = document.querySelectorAll(".lb-upsell-ppa-title-cont");
      offerTitles.forEach((title) => {
        setTimeout(() => {
        title.parentElement.style.opacity = 1;
    }, 1000);
       
  var convertedTtitle = title.innerText.toLowerCase();

           

        if (convertedTtitle.includes("protect your product")) {
          title.parentElement.classList.add('warranty-offer')
           // Find the element with the class "lb-upsell-ppa-title-cont"

// Check if the protection plan element already exists
var protectionPlanElement = document.querySelector('.protection-plan-element');
if (!protectionPlanElement) {
  // Create a new paragraph element
  protectionPlanElement = document.createElement('p');
  protectionPlanElement.textContent = 'Add a protection plan to your purchase';
  protectionPlanElement.style.marginLeft = '60px';
  protectionPlanElement.style.marginBottom = '20px';
  protectionPlanElement.style.marginTop = '-20px';
  protectionPlanElement.classList.add('protection-plan-element');

  // Insert the new paragraph element after the target element
  title.parentNode.insertBefore(protectionPlanElement, title.nextSibling);
}
               
          console.log('This is a "Warranty" offer');
        } 
      });
    }
  },
  false
);

document.addEventListener(
  "codeblackbelt:frequently-bought-together:rendered",
  function (event) {
    console.log("started");
    $(".cbb-frequently-bought-selector-link").each(function (e) {
      $(this).replaceWith(
        $(
          '<span class="cbb-frequenty-bought-selector-link">' +
            this.innerHTML +
            "</span>"
        )
      );
    });

    $(".cbb-frequently-bought-selector-list li").each(function (e) {
      $(this).wrapInner("<div class='details-container'></div>");

      $(
        '<span class="item_selector"></span><a data-bp="" class="thumb_container"></a>'
      ).prependTo($(this));
    });

    $(".cbb-frequently-bought-products .cbb-frequently-bought-product").each(
      function (index) {
        var bg = $(this)
          .find(".cbb-frequently-bought-product-image")
          .css("background-image");
        bg = bg.replace(/.*\s?url\([\'\"]?/, "").replace(/[\'\"]?\).*/, "");
        console.log(bg);
        var bigBg = bg.replace("_250x250", "");
        console.log($(".cbb-frequently-bought-selector li:nth-child(1)"));
        $(
          ".cbb-frequently-bought-selector-list li:nth-child(" +
            (index + 1) +
            ")"
        )
          .find(".thumb_container")
          .css("background-image", "url(" + bg + ")");
        $(
          ".cbb-frequently-bought-selector-list li:nth-child(" +
            (index + 1) +
            ")"
        )
          .find(".thumb_container")
          .attr("data-bp", bigBg);
      }
    );

    var cbbSelects = [];
    var cbbItems = document.querySelectorAll(
      ".cbb-recommendations-variant-select"
    );

    cbbItems.forEach((item) => {
      var searchEnabled = item.querySelectorAll("option").length > 5;
      cbbSelects.push(
        new Choices(item, {
          shouldSort: false,
          searchEnabled: searchEnabled,
          itemSelectText: "",
          position: "bottom",
        })
      );
    });
  }
);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
    $("#smile-ui-container").css(
      "z-index",
      !event.currentTarget.closest("details").hasAttribute("open")
        ? "2"
        : "1000"
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", (event) => {
      if (event.target.classList.contains("product_page_quantity_input")) {
        if (document.querySelector(".rewards_container")) {
          quantity = this.input.value;
          var placeholder = document.querySelector(".rewards_placeholder");
          var prefix = document.getElementById("rewardsPrefix").innerHTML;
          var suffix = document.getElementById("rewardsSuffix").innerHTML;
          if (document.documentElement.classList.contains("t-monarch")) {
            var total_reward = (reward_value / points_price) * total;
            document.querySelector(
              ".rewards_container"
            ).innerHTML = `<span>${prefix}</span><span class="points_value">${(
              total_reward * quantity
            ).toFixed(2)}</span><span>&nbsp;${suffix}</span>`;
          } else {
            document.querySelector(
              ".rewards_container"
            ).innerHTML = `<span>${prefix}</span><span class="points_value">${(
              points * quantity
            ).toFixed(2)}</span><span>&nbsp;${suffix}</span>`;
          }
        }
      }
    });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    deleteVariants();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku();
      this.updateFinancingForm();
      if (document.querySelector(".rewards_container")) {
        console.log(this.currentVariant.price);
        console.log(this.currentVariant.price / 100);
        console.log(reward_value);
        console.log(points_price);

        points =
          (reward_value / points_price) * (this.currentVariant.price / 100);
        points = points.toFixed(2);

        var placeholder = document.querySelector(".rewards_placeholder");
        var prefix = document.getElementById("rewardsPrefix").innerHTML;
        var suffix = document.getElementById("rewardsSuffix").innerHTML;

        document.querySelector(".rewards_container").innerHTML =
          prefix + (points * quantity).toFixed(2) + suffix;
      }
    }
  }

  updateSku() {
    getSku(this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".select__select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateFinancingForm() {
    var financingForm = document.getElementById("FinancingForm");
    if (financingForm) {
      const locale = "en-CA";
      const price = this.currentVariant.price / 100;

      const numberFormat = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2,
      });

      const formattedPrice = numberFormat.format(price);

      document.getElementById("FinancingForm-variant").value =
        this.currentVariant.name;
      document.getElementById("FinancingForm-sku").value =
        this.currentVariant.sku;
      document.getElementById("FinancingForm-price").value = formattedPrice;
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `inventory-${this.dataset.section}`
        );
        const rewards = document.querySelector(".rewards_container");

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
        if (inventory)
          inventory?.classList.remove("visibility-hidden"),
            rewards?.classList.remove("visibility-hidden"),
            this.updateInventory(html);
      });
  }

  updateInventory(html) {
    const id = `inventory-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `inventory-${this.dataset.section}`
    );
    const rewards = document.querySelector(".rewards_container");
    if (inventory)
      inventory.classList.add("visibility-hidden"),
        rewards.classList.add("visibility-hidden");

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);



class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);


class CombinedVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.variantCache = new Map();
    this.initFromUrl();
  }

  initFromUrl() {
    try {
      const select = this.querySelector('select');
      if (!select) return;

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        const option = select.querySelector(`option[data-variant-id="${variantId}"]`);
        if (option) {
          select.value = option.value;
          this.onVariantChange();
        }
      } else {
        const selectedOption = select.selectedOptions[0];
        if (selectedOption) {
          const option = select.querySelector(`option[data-variant-id="${selectedOption.dataset.variantId}"]`);
          if (option) {
            select.value = option.value;
            this.onVariantChange();
          }
        }
      }
    } catch (error) {
      console.error('Error initializing variant from URL:', error);
    }
  }




  async onVariantChange() {
    await this.updateOptions();
    await this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      await this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku();
      this.updateFinancingForm();
    }
  }

  async updateMasterId() {
    const select = this.querySelector("select");
    const selectedOption = select.selectedOptions[0];
    const productUrl = selectedOption.dataset.productUrl;
    const variantId = selectedOption.dataset.variantId;
    
    if (!this.variantCache.has(variantId)) {
      const variantData = await this.fetchVariantData(productUrl, variantId);
      this.variantCache.set(variantId, variantData);
    }
    
    this.currentVariant = this.variantCache.get(variantId);
  }

  async fetchVariantData(productUrl, variantId) {
    try {
      const fetchUrl = `${productUrl}?variant=${variantId}&section_id=${this.dataset.section}`;
      const response = await fetch(fetchUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const jsonData = html.querySelector('[type="application/json"]');
      
      if (!jsonData) return null;
      
      return JSON.parse(jsonData.textContent).find(variant => variant.id.toString() === variantId);
    } catch (error) {
      console.error('Error fetching variant data:', error);
      return null;
    }
  }

  async updateOptions() {
    this.options = [this.querySelector("select").value];
  }
  
  async updateInventory(html) {
    try {
      const select = this.querySelector("select");
      const selectedOption = select.selectedOptions[0];
      const productUrl = selectedOption.dataset.productUrl;
      const variantId = selectedOption.dataset.variantId;

      const fetchUrl = `${productUrl}?variant=${variantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`;

      const response = await fetch(fetchUrl);
      const responseText = await response.text();
      const parsedHtml = new DOMParser().parseFromString(responseText, "text/html");

      const id = `inventory-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = parsedHtml.getElementById(id);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

    } catch (error) {
      console.error('Error updating inventory:', error);
    }
  }

async renderProductInfo() {
  try {
    const select = this.querySelector("select");
    const selectedOption = select.selectedOptions[0];
    const productUrl = selectedOption.dataset.productUrl;
    const variantId = selectedOption.dataset.variantId;

    const fetchUrl = `${productUrl}?variant=${variantId}&section_id=${
      this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
    }`;

    const response = await fetch(fetchUrl);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, "text/html");

    const destination = document.getElementById(`price-${this.dataset.section}`);
    const source = html.getElementById(
      `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
    );

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }

    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`inventory-${this.dataset.section}`);
    const rewards = document.querySelector(".rewards_container");

    if (price) {
      price.classList.remove("visibility-hidden");
    }

    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

    if (inventory) {
      inventory.classList.remove("visibility-hidden");
      rewards?.classList.remove("visibility-hidden");
      this.updateInventory(html);
    }

  } catch (error) {
    console.error('Error rendering product info:', error);
  }
}
}

  


customElements.define('combined-variant-selects', CombinedVariantSelects);


var choices = [];
const items = document.querySelectorAll(".custom_select");

items.forEach((item) => {
  var searchEnabled = item.querySelectorAll("option").length > 8;
  choices.push(
    new Choices(item, {
      shouldSort: false,
      itemSelectText: "",
      searchEnabled: searchEnabled,
      position: "bottom",
    })
  );
});

// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
"Shoppad.apps.infiniteoptions".split(".").reduce(function (o, x) {
  if (!o[x]) {
    o[x] = {};
  }
  return o[x];
}, window);

// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function (subscribe) {
  subscribe("appLoad", function (event) {
    console.log("appLoad", event);

    const selects = document.querySelectorAll("select");

    selects.forEach((item) => {
      const searchEnabled = item.querySelectorAll("option").length > 5;
      new Choices(item, {
        shouldSort: false,
        itemSelectText: "",
        searchEnabled: searchEnabled,
        position: "bottom",
      });
    });

    document.dispatchEvent(new CustomEvent("optionsLoaded"));
  });
};

/* new CircleType(document.getElementById('slogan')); */

function maybeRedirect(selectedLang, lang) {
  console.log(selectedLang);
  if (selectedLang == "FR" && lang == "en") {
    console.log(document.location.href);
    document.getElementById("register_lang_loading_text").innerHTML =
      "Nous enregistrons vos préférences linguistiques";

    var new_location = document.location.href.replace(
      "https://",
      "https://fr."
    );
    var new_location_subdir = new_location.replace("account", "fr/account");
    console.log(new_location_subdir);
    document.querySelector(".loader").classList.add("loader-visible");
    setTimeout(() => {
      document.querySelector(".loader").classList.remove("loader-visible");
    }, 5000);
    setTimeout(() => {
      document.location.href = new_location_subdir;
    }, 1000);
  }
  if (selectedLang == "EN" && lang == "fr") {
    console.log(document.location.href);
    var new_location = document.location.href.replace(
      "https://fr.",
      "https://"
    );
    var new_location_subdir = new_location.replace("fr/account", "account");
    console.log(new_location_subdir);
    document.querySelector(".loader").classList.add("loader-visible");
    document.getElementById("register_lang_loading_text").innerHTML =
      "We are storing your language preferences";
    setTimeout(() => {
      document.querySelector(".loader").classList.remove("loader-visible");
    }, 5000);
    setTimeout(() => {
      document.location.href = new_location_subdir;
    }, 1000);
  }

  if (
    selectedLang == "FR" &&
    lang == "fr" &&
    !window.location.pathname.includes("/fr")
  ) {
    document.getElementById("register_lang_loading_text").innerHTML =
      "Nous enregistrons vos préférences linguistiques";
    document.querySelector(".loader").classList.add("loader-visible");

    setTimeout(() => {
      document.querySelector(".loader").classList.remove("loader-visible");
    }, 5000);

    setTimeout(() => {
      document.location.href = document.location.href.replace(
        "account",
        "fr/account"
      );
    }, 1000);
  }

  return;
}

function trimLinks(domainPrefix) {
  if (domainPrefix == "fr") {
    $(".header__heading-link").attr("href", "/");
    $("a")
      .not(".glink")
      .each(function () {
        $(this).attr("href", $(this).attr("href").replace("fr/", ""));
      });
  }
}

/*CUSTOM CHECKOUT REDIRECT */
function checkout_redirect() {
  var url = new URL(window.location.href);
  var lang = /:\/\/([^\/]+)/.exec(window.location.href)[1].split(".")[0];
  console.log(lang);
  if (lang == "fr" && url.searchParams.get("checkout_url") != null) {
    var hiddenInputs = document.getElementsByName("checkout_url");
    hiddenInputs.forEach((hiddenInput) => {
      hiddenInput.value = "/fr/checkout";
    });
  }
  if (document.getElementById("customer_login")) {
    document.getElementById("customer_login").action = "/account/login";
  }

  if (lang == "fr") {
    if (document.getElementById("cart")) {
      document.getElementById("cart").action = "/fr/cart";
    }
    if (document.getElementById("CartDrawer-Form")) {
      document.getElementById("CartDrawer-Form").action = "/fr/cart";
    }
  }
}

function register_redirect(lang, has_cart) {
  if (has_cart == "true") {
    if (lang == "fr" && !location.pathname.includes("/fr")) {
      document.getElementsByName("return_to")[0].value = "/fr/checkout";
    } else {
      document.getElementsByName("return_to")[0].value = "/checkout";
    }
  } else {
    document.getElementsByName("return_to")[0].value = "/account";
  }
}

/*CUSTOM RECOVER PASSWORD REDIRECT */
function recover_redirect() {
  var lang = /:\/\/([^\/]+)/.exec(window.location.href)[1].split(".")[0];
  console.log(lang);
  if (lang == "fr") {
    document.getElementById("customer_recover_password").action =
      "/fr/account/login";
  }
}

window.addEventListener("DOMContentLoaded", () => {
  // similar behavior as an HTTP redirect
  pathname = location.pathname;
  if (pathname == "/fr") {
    window.location.replace("/");
  }

  if (pathname == "/fr/cart") {
    window.location.replace("/cart");
  }
});




document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll('.header__inline-menu details');

  menuItems.forEach((item) => {
    let timeout;

    item.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      item.setAttribute('open', true);
    });

    item.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        item.removeAttribute('open');
      }, 200); // small delay for smooth UX
    });
  });
});




document.addEventListener('DOMContentLoaded', function () {
    const mobileSearch = document.querySelector('.header-search.mobile-view');

    if (!mobileSearch) return;

    const originalParent = mobileSearch.parentNode;
    const originalNextSibling = mobileSearch.nextSibling;

    window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {

            if (mobileSearch.parentNode !== document.body) {
                document.body.appendChild(mobileSearch);
            }

    Object.assign(mobileSearch.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    width: '100%',
    height: '60px',
    margin: 'auto',
    padding:'15px',
    display: 'flex',
    alignItems: 'center',
    marginTop:'0px',
    zIndex: '999999',

    background: 'rgba(255, 255, 255, 0.65)',
    backdropFilter: 'blur(20px) saturate(180%)',
    WebkitBackdropFilter: 'blur(20px) saturate(180%)',

    border: '1px solid rgba(255,255,255,0.4)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
});

        } else {

            if (mobileSearch.parentNode === document.body) {
                if (originalNextSibling) {
                    originalParent.insertBefore(mobileSearch, originalNextSibling);
                } else {
                    originalParent.appendChild(mobileSearch);
                }
            }

            mobileSearch.removeAttribute('style');
        }
    });
});